// extracted by mini-css-extract-plugin
export default {"dot":"TeamColourDot_dot__UI7pf","none":"TeamColourDot_none__3EfMj","large":"TeamColourDot_large__EWLVn"};